export const currentOpt = state => state.currentOpt